const IsThisGraphQLLogo = ({
  ...props
}: React.SVGAttributes<SVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 32 32'
    width={32}
    height={32}
    {...props}
    fill='none'
  >
    <defs>
      <linearGradient
        id='c'
        x1='24.75'
        x2='24.75'
        y1='17.5'
        y2='26.251'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#3B4C6A' stopOpacity='0' />
        <stop offset='1' stopColor='#3B4C6A' stopOpacity='.03' />
      </linearGradient>
      <filter
        id='b'
        width='31.095'
        height='31.095'
        x='9.202'
        y='10.98'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='.081' />
        <feGaussianBlur stdDeviation='.188' />
        <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.2079 0' />
        <feBlend
          in2='BackgroundImageFix'
          result='effect1_dropShadow_1468:21979'
        />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='.223' />
        <feGaussianBlur stdDeviation='.519' />
        <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.04 0' />
        <feBlend
          in2='effect1_dropShadow_1468:21979'
          result='effect2_dropShadow_1468:21979'
        />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='.536' />
        <feGaussianBlur stdDeviation='1.251' />
        <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0521271 0' />
        <feBlend
          in2='effect2_dropShadow_1468:21979'
          result='effect3_dropShadow_1468:21979'
        />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='1.778' />
        <feGaussianBlur stdDeviation='4.149' />
        <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.08 0' />
        <feBlend
          in2='effect3_dropShadow_1468:21979'
          result='effect4_dropShadow_1468:21979'
        />
        <feBlend
          in='SourceGraphic'
          in2='effect4_dropShadow_1468:21979'
          result='shape'
        />
      </filter>
    </defs>
    <path
      fill='#3B4C6A'
      fillOpacity='.4'
      d='M6.19 15.9v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm3.13 6.8l1 .58a1.52 1.52 0 011-.43 1.49 1.49 0 011 .43l1-.58h-4zm-3.13-6.8v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm3.13 6.8l1 .58a1.52 1.52 0 011-.43 1.49 1.49 0 011 .43l1-.58h-4zm-3.13-6.8v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm3.13 6.8l1 .58a1.52 1.52 0 011-.43 1.49 1.49 0 011 .43l1-.58h-4zm0 0l1 .58a1.52 1.52 0 011-.43 1.49 1.49 0 011 .43l1-.58h-4zm-3.13-6.8v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm3.13 6.8l1 .58a1.52 1.52 0 011-.43 1.49 1.49 0 011 .43l1-.58h-4zm5.53 0l-2.09 1.23c.04.126.061.258.06.39a1.5 1.5 0 11-3 0c-.001-.133.02-.264.06-.39l-3.02-1.81a1.51 1.51 0 01-1 .43 1.47 1.47 0 01-1.48-1.47 1.45 1.45 0 011.1-1.42v-3.77a1.45 1.45 0 01-1.1-1.42A1.47 1.47 0 015.82 13c.2-.001.397.04.58.12v-6.7H2.65A2.65 2.65 0 000 9.07v17.4a2.64 2.64 0 002.65 2.65h17.4a2.65 2.65 0 002.65-2.65V22.7h-7.85zm-8.66-6.8v3.75l.21-.37v-3.45l-.21.07zm3.13 6.8l1 .58a1.52 1.52 0 011-.43 1.49 1.49 0 011 .43l1-.58h-4zm0 0l1 .58a1.52 1.52 0 011-.43 1.49 1.49 0 011 .43l1-.58h-4zm-3.13-6.8v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm3.13 6.8l1 .58a1.52 1.52 0 011-.43 1.49 1.49 0 011 .43l1-.58h-4zm-3.13-6.8v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm3.13 6.8l1 .58a1.52 1.52 0 011-.43 1.49 1.49 0 011 .43l1-.58h-4zm-3.13-6.8v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm3.13 6.8l1 .58a1.52 1.52 0 011-.43 1.49 1.49 0 011 .43l1-.58h-4zm-3.13-6.8v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07zm0 0v3.75l.21-.37v-3.45l-.21.07z'
    />
    <path
      fill='#3B4C6A'
      fillOpacity='.8'
      d='M26.45 0H9.05A2.65 2.65 0 006.4 2.65v17.4a2.65 2.65 0 002.65 2.65h17.4a2.65 2.65 0 002.65-2.65V2.65A2.65 2.65 0 0026.45 0z'
    />
    <path
      stroke='#fff'
      strokeMiterlimit='10'
      strokeWidth='.75'
      d='M23.28 8.05v6.61H12.22V8.05M12.22 8.05l5.53-3.25 5.53 3.25'
    />
    <path
      stroke='#fff'
      strokeMiterlimit='10'
      strokeWidth='.75'
      d='M23.28 14.65l-5.53 3.25-5.53-3.25'
    />
    <path
      fill='#fff'
      d='M23.28 16.12a1.47 1.47 0 100-2.94 1.47 1.47 0 000 2.94zM23.28 9.52a1.47 1.47 0 100-2.94 1.47 1.47 0 000 2.94zM17.75 6.27a1.47 1.47 0 100-2.94 1.47 1.47 0 000 2.94zM17.75 19.37a1.47 1.47 0 100-2.94 1.47 1.47 0 000 2.94zM12.22 9.52a1.47 1.47 0 100-2.94 1.47 1.47 0 000 2.94zM12.22 16.12a1.47 1.47 0 100-2.94 1.47 1.47 0 000 2.94z'
    />
    <path
      stroke='#fff'
      strokeMiterlimit='10'
      strokeWidth='.75'
      d='M12.22 14.65l5.53-9.85 5.53 9.85'
    />
    <g filter='url(#b)'>
      <path
        fill='#fff'
        d='M24.75 32a7.25 7.25 0 100-14.5 7.25 7.25 0 000 14.5z'
      />
      <path
        fill='url(#c)'
        d='M24.75 32a7.25 7.25 0 100-14.5 7.25 7.25 0 000 14.5z'
      />
    </g>
    <path
      fill='#3B4C6A'
      fillOpacity='.8'
      d='M24.1 24.3l.2 1.9h.9l.1-.9c.3-.1.6-.1.9-.2.245-.111.48-.245.7-.4.221-.19.393-.43.5-.7a2.92 2.92 0 00.2-.9 3.001 3.001 0 00-.2-1 1.79 1.79 0 00-.5-.7 2.18 2.18 0 00-.8-.5 3.59 3.59 0 00-1.1-.2 2.93 2.93 0 00-1.6.4c-.445.234-.85.538-1.2.9l.8.9c.3-.3.6-.5.8-.7a1.64 1.64 0 011-.2 1.69 1.69 0 011 .3c.23.207.372.493.4.8a1.05 1.05 0 01-.5.9 3.51 3.51 0 01-1.6.3zm1.4 4.4v-1.6H24v1.6h1.5z'
    />
  </svg>
)

export default IsThisGraphQLLogo
